<template>
<pop-up-layout
  :title="$t('general.popUpConfirmacion.activarCuenta')"
  :loading="loading"
  :saving="waitingForLoad"
  :loadingText="$t('general.misc.cargando')"
  :description="textoDesc"
>
  <v-layout mb-3 justify-center>
    <v-icon color="primary" class="custom-icon icon-job" style="font-size:200px;"/>
  </v-layout>
  <template #acciones>
    <v-layout wrap justify-center align-center>
        <v-flex xs12>
          <v-layout wrap justify-center>
            <v-btn
              large
              color="primary"
              :disabled="waitingForLoad || loading"
              :loading="waitingForLoad"
              @click="mandarCorreo()"
            >
            {{$t('general.popUpConfirmacion.reEnviarEmail')}}
            </v-btn>
            <v-btn
              large
              color="primary"
              :disabled="waitingForLoad || loading"
              :loading="waitingForLoad"
              @click="comprobar()"
            >
              {{$t('general.misc.continuar')}}
            </v-btn>
          </v-layout>
        </v-flex>
        <v-flex v-if="!incrustado">
          <o-btn-volver
            @volver="$emit('volver')"
            :disabled="waitingForLoad || loading"
          />
        </v-flex>
    </v-layout>
  </template>
</pop-up-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      loading: false,
      waitingForLoad: false
    }
  },
  props: {
    incrustado: {
      type: Boolean,
      default: false
    }
  },
  async created () {
    try {
      this.loading = true
      await this.loadReserva(this.reserva.id)
      this.loading = false
    } catch (error) {
      this.addAlert({texto: this.$t('general.misc.noEncuentraReserva'), color: 'error'})
    }
  },
  computed: {
    ...mapGetters({
      reserva: 'reservas/_id/getActual'
    }),
    textoDesc () {
      return this.$t('general.popUpConfirmacion.seHaEnviadoCorreo', {email: (this.reserva.actor ? this.reserva.actor.email : '')})
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      reenviarCorreo: 'login/reenviarMail',
      loadReserva: 'reservas/_id/load'
    }),
    async comprobar () {
      try {
        this.waitingForLoad = true
        await this.loadReserva(this.reserva.id)
        if (this.reserva.actorConfirmacion == null || this.reserva.actorConfirmacion.token != null) {
          this.addAlert({texto: this.esSoloCliente ? this.$t('general.popUpConfirmacion.compruebeCorreoCliente') : this.$t('general.popUpConfirmacion.compruebeCorreoNoCliente'), color: 'error'})
        } else {
          this.$parent.noCerrarInterno = false
          this.$parent.hide()
          if (this.incrustado) {
            this.$router.push({name: 'incrustado.stepper'})
          }
        }
        this.waitingForLoad = false
      } catch (error) {
        this.addAlert({texto: this.$t('general.misc.noEncuentraReserva'), color: 'error'})
      }
    },
    async mandarCorreo () {
      try {
        this.waitingForLoad = true
        await this.reenviarCorreo(this.reserva.actorId)
        this.addAlert({texto: this.$t('general.popUpConfirmacion.envioCorreoCorrecto'), color: 'success'})
        this.waitingForLoad = false
      } catch (error) {
        this.waitingForLoad = false
        this.addAlert({texto: error.message, color: 'error'})
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/generic/PopUpConfirmacion.vue